import { render } from "./Test2.vue?vue&type=template&id=330bc5ec"
import script from "./Test2.vue?vue&type=script&lang=js"
export * from "./Test2.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Test2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "330bc5ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('330bc5ec', __exports__)) {
    api.reload('330bc5ec', __exports__)
  }
  
  module.hot.accept("./Test2.vue?vue&type=template&id=330bc5ec", () => {
    api.rerender('330bc5ec', render)
  })

}


export default __exports__